// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.css
// module id = 1144
// module chunks = 0